var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgRedirect = function SvgRedirect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 10,
    fill: "#602FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.94 14.568l-1.288-1.288a.75.75 0 011.06-1.06l2.475 2.475a.75.75 0 01-.106 1.149.764.764 0 01-.015.015l-2.475 2.475a.75.75 0 01-1.06-1.06l1.205-1.206H11.75a.75.75 0 010-1.5h5.19z"
  }))));
};
export default SvgRedirect;